module.exports = __webpack_public_path__ + "static/media/filter_icon.158cf7d2.svg";